import {authorFromTypeToTitle} from '@/data/pl/authorFromTypeToTitle';

import blogpost_data from '@/data/blog-post.data';

const authorSlugMap = {
  "pl": '/pl/o-nas/',
  "en-GB": '/uk/about-us/',
  "uk": '/ua/pro-nas/',
  "de": '/de/uber-uns/',
  "cs": "/cz/o-nas",
  "ro": "/ro/despre-noi",
  "hu": "/hu/rolunk",
  "sk": "/sk/o-nas",
  "bg": "/bg/za-nas",
  "fr": "/fr/a-propos",
  "it": "/it/chi-siamo",
  "es": "/es/acerca-de",
  "nl": "/nl/over-ons",
  "sv": "/sv/om-oss",
  "pt": "/pt/sobre-nos",
  "da": "/da/om-os",
  "fi": "/fi/tietoa-meista"  
}

const parseAuthor = (data, role, locale) => {
  const title = authorFromTypeToTitle[locale][role];
  const isVerified = role === 'reviewedBy';


  let href = locale === `${authorSlugMap[locale]}${data.slug}`;

  return {
    href: data?.hasAuthorPage && data?.slug ? href : null,
    picture: {
      src: data?.imageSmall?.url || null,
      alt: `${data?.firstName} ${data?.lastName} - ${title}`
    },
    title: title,
    name: `${data?.firstName} ${data?.lastName}`,
    role: data?.role,
    verifiedLabel: isVerified ? blogpost_data[locale].hero.tooltip.labelVerified : null,
    details: {
      description: data?.description,
      socials: {
        linkedin: data?.linkedin,
        muckrack: data?.muckrack
      },
      footerText: blogpost_data[locale].hero.tooltip.footerText,
    },
  };
};

export const getAuthorsArray = (post, roles, locale) => {
  const authorsObject = roles.reduce((acc, role) => {
    if (post[role]) {
      acc[role] = parseAuthor(post[role], role, locale);
    }
    return acc;
  }, {});

  return Object.values(authorsObject).filter(author => author);
};
